import React from 'react';
import { Clock, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { TabsContent } from '../../../components/ui/tabs';
import { ContentItemCard } from '../components/AdminComponents';

const ReviewsTab = ({ pendingItems, handleReview, handleSetPrice, handleEdit, getItemIcon, getItemTitle }) => (
    <TabsContent value="reviews">
        <Card>
            <CardHeader>
                <div className="flex items-center justify-between">
                    <div>
                        <CardTitle className="flex items-center">
                            <Clock className="h-5 w-5 mr-2 text-yellow-600" />
                            Pending Reviews
                        </CardTitle>
                        <CardDescription>Review and approve content before it goes live</CardDescription>
                    </div>
                    <Badge variant="outline" className="text-lg px-4 py-1">
                        {pendingItems.length} pending
                    </Badge>
                </div>
            </CardHeader>
            <CardContent>
                {pendingItems.length === 0 ? (
                    <div className="text-center py-16 text-gray-500">
                        <CheckCircle className="h-20 w-20 mx-auto mb-4 text-green-400" />
                        <p className="text-xl font-medium">All caught up!</p>
                        <p className="text-gray-400">No pending items to review</p>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {pendingItems.map((item) => (
                            <ContentItemCard
                                key={`${item.type}-${item.id}`}
                                item={item}
                                onReview={handleReview}
                                onSetPrice={handleSetPrice}
                                onEdit={handleEdit}
                                getItemIcon={getItemIcon}
                                getItemTitle={getItemTitle}
                            />
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    </TabsContent>
);

export default ReviewsTab;
